export enum ConfidenceBiasZoneLabel {
	Timid = 'TIMID',
	Optimal = 'OPTIMAL',
	Aggressive = 'AGGRESSIVE',
}
